/**
 * open-registry.ts — shared helper to create a full AssetKindRegistry.
 *
 * Bootstraps the registry with all built-in providers (9 core + preset)
 * from @skaile/discovery, plus the extension kind providers (flow from
 * @skaile/workspaces/factory-assets/connectors/flow/engine, knowledge from @skaile/library).
 *
 * This is the single registration point for the CLI. All code paths
 * that need a registry (source sync, lib-status, etc.) should use this.
 */

import type { AssetKindRegistry } from "@skaile/workspaces/discovery";
import { createDefaultRegistry } from "@skaile/workspaces/discovery";
import { flowKindProvider } from "@skaile/workspaces/factory-assets/connectors/flow/engine";
import { knowledgeKindProvider } from "@skaile/workspaces/library";

/**
 * Create a fully-configured AssetKindRegistry with all known providers.
 *
 * Registers:
 * - 9 core kinds (skill, agent, connector, mount, mcp-server, contract, prompt, persona, ruleset)
 * - preset (composition entity)
 * - flow (extension, from @skaile/workspaces/factory-assets/connectors/flow/engine)
 * - knowledge (extension, from @skaile/library)
 *
 * @returns An unfrozen registry (auto-freezes on first read)
 */
export function createFullRegistry(): AssetKindRegistry {
  const registry = createDefaultRegistry();
  registry.register(flowKindProvider);
  registry.register(knowledgeKindProvider);
  return registry;
}
